export function formatSessionDateTime(
  dateStr?: string | null,
  tzIdentifier?: string | null,
  tzShortName?: string | null,
): string {
  if (!dateStr) return "--";

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "--";

  let dateTimeFormatted = "";
  if (!tzIdentifier) {
    dateTimeFormatted = date.toLocaleString([], {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } else {
    dateTimeFormatted = new Intl.DateTimeFormat("en-US", {
      timeZone: tzIdentifier,
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  }

  if (tzShortName) {
    dateTimeFormatted += ` (${tzShortName})`;
  }

  return dateTimeFormatted;
}
